import { motion } from "framer-motion";
import { Check, ArrowRight, Zap } from "lucide-react";

const INCLUDES = [
  "2 property reels edited from supplied footage",
  "3 branded property social media creatives",
  "1 cover design for a listing or reel",
  "1 consolidated revision round per asset",
  "Delivery within 7 calendar days",
];

export const Sprint = ({ onClaim }) => {
  return (
    <section id="sprint" data-testid="sprint-section" className="py-16 sm:py-24 bg-[#0b1426]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="relative overflow-hidden rounded-[2rem] border border-[#fba31b]/30 bg-gradient-to-br from-[#162544] via-[#12203c] to-[#0b1426] p-8 sm:p-12"
        >
          <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-[#fba31b]/15 blur-[100px] pointer-events-none" />

          <div className="relative grid lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-3 relative h-56 sm:h-64 hidden sm:block">
              <div className="absolute left-0 top-4 w-[70%] h-[85%] rounded-2xl overflow-hidden border border-white/10 rotate-[-4deg] shadow-2xl">
                <img src="https://images.pexels.com/photos/36134146/pexels-photo-36134146.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" alt="Property creative sample" className="w-full h-full object-cover" />
              </div>
              <div className="absolute right-0 top-0 w-[62%] h-[78%] rounded-2xl overflow-hidden border border-[#fba31b]/40 rotate-[5deg] shadow-2xl">
                <img src="https://images.unsplash.com/photo-1779648596373-274e9d81ad80?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjB2aWxsYSUyMGludGVyaW9yJTIwZHViYWklMjBhcGFydG1lbnQlMjBtb2Rlcm4lMjByZWFsJTIwZXN0YXRlfGVufDB8fHx8MTc5MjY2OTg3Nnww&ixlib=rb-4.1.0&q=85" alt="Luxury villa interior" className="w-full h-full object-cover" />
              </div>
              <span className="absolute -left-2 -top-3 inline-flex items-center gap-1.5 bg-[#fba31b] text-[#12203c] text-[10px] font-extrabold uppercase tracking-wider px-3 py-1.5 rounded-lg rotate-[-6deg]">
                <Zap className="w-3 h-3" /> 7-Day Sprint
              </span>
            </div>

            <div className="lg:col-span-5">
              <p className="font-code text-xs uppercase tracking-[0.25em] text-[#fba31b] font-bold">Try Us First</p>
              <h3 className="font-display mt-3 text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight">
                The Dubai Property Creative Sprint
              </h3>
              <div className="mt-4 flex items-baseline gap-3">
                <span className="font-display text-3xl sm:text-4xl font-extrabold text-[#fba31b]">AED 750 – 950</span>
                <span className="text-slate-400 text-sm">one-time</span>
              </div>
              <p className="mt-4 text-sm sm:text-base text-slate-300 leading-relaxed">
                Not ready for a monthly plan? Test our execution on one live listing before you commit. Full studio workflow, real deliverables, zero retainers.
              </p>
              <button
                data-testid="claim-sprint-btn"
                onClick={onClaim}
                className="mt-7 inline-flex items-center gap-2 bg-[#fba31b] hover:bg-[#e59312] text-[#12203c] font-bold px-7 py-3.5 rounded-full text-sm transition-colors hover:shadow-[0_0_30px_rgba(251,163,27,0.45)]"
              >
                Claim Your Creative Sprint <ArrowRight className="w-4 h-4" />
              </button>
            </div>

            <div className="lg:col-span-4 rounded-2xl bg-[#0b1426]/60 border border-white/10 p-6">
              <p className="font-code text-[10px] uppercase tracking-[0.2em] text-slate-400 mb-4">What's included</p>
              <ul className="space-y-3.5">
                {INCLUDES.map((item) => (
                  <li key={item} className="flex items-start gap-2.5 text-sm text-slate-200">
                    <Check className="w-4 h-4 mt-0.5 text-[#fba31b] shrink-0" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
